import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AdvancedStore = {
  showAdvanced: boolean;
  setShowAdvanced: (value: boolean) => void;
  selections: Record<string, boolean>;
  setSelection: (settingKey: string, value: boolean) => void;
};

export const useAdvancedStore = create<AdvancedStore>()(
  persist(
    (set) => ({
      showAdvanced: false,
      setShowAdvanced: (value: boolean) =>
        set(() => ({
          showAdvanced: value,
        })),
      selections: {},
      setSelection: (settingKey, value) =>
        set((state) => ({
          selections: { ...state.selections, [settingKey]: value },
        })),
    }),
    {
      name: "advanced-store",
    },
  ),
);
